<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>事件查看
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" :class="className">
            <el-form-item label="设备名称">
              <el-input placeholder="请输入设备名称" v-model="seefrom.deviceName"></el-input>
            </el-form-item>
            <el-form-item label="设备编码">
              <el-input placeholder="请输入设备编码" v-model="seefrom.deviceId"></el-input>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="seefrom.startTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="seefrom.endTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="所属区域">
              <el-input
                placeholder="请选择区域"
                v-model="seefrom.deviceRegionName"
                @focus="changeAreaMode(1)"
              ></el-input>
            </el-form-item>
            <el-form-item label="应用系统">
              <el-select
                v-model="seefrom.deviceSystemId"
                placeholder="请选择应用系统"
                @change="_deviceTypeChange"
              >
                <el-option
                  v-for="item in systemArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型">
              <el-select v-model="seefrom.deviceType" placeholder="请选择设备类型">
                <el-option
                  v-for="item in deviceTypeList"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="事件类型">
              <el-select v-model="seefrom.eventType" placeholder="请选择事件类型">
                <el-option
                  v-for="item in eventTypeList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <template>
              <span class="collapseIcon" @click="className = 'expand'"
                ><img :src="require('public/searchForm/collapse.png')" alt=""
              /></span>
              <span class="expandIcon" @click="className = 'collapse'"
                ><img :src="require('public/searchForm/expand.png')" alt=""
              /></span>
            </template>
          </el-form>
        </div>
        <div class="tableWapper">
          <easyTable
            apiUrl="extra/deviceEvent/page"
            :parent="self"
            :config="config"
            :other="other"
            ref="table_jsgl"
          >
            <template slot="last">
              <el-table-column label="操作" width="200" align="left">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="_see(scope.$index, scope.row)"
                    >详情</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
      </el-tab-pane>
    </el-tabs>
    <mountPoint
      :hasChildNodes="areaTreeMode"
      :dialogVisible="areaTreeVisible"
      @regionTreeClose="areaTreeVisible = false"
      @regionTreeData="selRegionData"
    ></mountPoint>
    <el-dialog
      class="editDialog"
      :visible.sync="displayForm"
      title="详情"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="发生时间:">
          <p>{{ detailList.createTime }}</p>
        </el-form-item>
        <el-form-item label="所属区域:">
          <p>{{ detailList.deviceRegionName }}</p>
        </el-form-item>
        <el-form-item label="应用系统:">
          <p>{{ detailList.systemName }}</p>
        </el-form-item>
        <el-form-item label="设备类型:">
          <p>{{ detailList.deviceTypeName }}</p>
        </el-form-item>
        <el-form-item label="设备名称:">
          <p>{{ detailList.deviceName }}</p>
        </el-form-item>
        <el-form-item label="设备编码:">
          <p>{{ detailList.deviceId }}</p>
        </el-form-item>
        <el-form-item label="事件类型:">
          <p>{{ detailList.eventTypeName }}</p>
        </el-form-item>
        <el-form-item label="事件内容:">
          <p>{{ detailList.eventContent }}</p>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        detailList: {},
        displayForm: false,
        className: 'collapse',
        //区域树是否显示
        areaTreeVisible: false,
        inputReadOnly: false,
        //区域树模式选择
        areaTreeMode: true,
        //选择区域树模式 查询 ？ 新增 ？
        areaMode: 1,
        seefrom: {
          deviceName: '',
          deviceId: '',
          startTime: '',
          endTime: '',
          deviceRegion: '',
          deviceSystemId: '',
          deviceType: '',
          eventType: ''
        },
        deviceTypeList: [], // 设备类型列表
        eventTypeList: [
          // {id:1 , value:'报警'},
          { id: 2, value: '故障' },
          { id: 3, value: '动作' }
        ], // 事件类型列表
        systemArr: [], // 应用系统列表
        title: '',
        tabName: 'jsgl',
        other: {},
        form_jsgl: {},
        items: [
          {
            type: 'input',
            prop: 'name',
            label: '用户姓名',
            placeholder: '请输入用户姓名',
            option: {}
          },
          {
            type: 'input',
            prop: 'phone',
            label: '用户手机',
            placeholder: '请输入用户手机',
            option: {}
          }
        ]
      }
    },
    computed: {
      self() {
        return this
      },
      config() {
        return [
          {
            prop: 'createTime',
            label: '发生时间'
          },
          {
            prop: 'deviceRegionName',
            label: '所属区域'
          },
          {
            prop: 'deviceName',
            label: '设备名称'
          },
          {
            prop: 'eventContent',
            label: '事件内容'
          },
          {
            prop: 'deviceId',
            label: '设备编码'
          }
        ]
      },
      dt() {
        return dt.map(({ label }) => label)
      }
    },
    components: {
      normalNav: () => import('public/normalNav'),
      easyTable: () => import('public/easyTable'),
      searchForm: () => import('public/searchForm'),
      mountPoint: () => import('public/mountPoint')
    },
    methods: {
      // 选中的应用系统
      _deviceTypeChange(e) {
        // 设备类型
        this.$axiosget('manager/operatingSystemApi/getDeviceTypeByOperatingId', {
          params: {
            id: e
          }
        }).then(res => {
          this.deviceTypeList = res.data.data
        })
      },
      reset() {
        this.seefrom = {
          deviceName: '',
          deviceId: '',
          startTime: '',
          endTime: '',
          deviceRegion: '',
          deviceSystemId: '',
          deviceType: '',
          eventType: ''
        }
      },
      // 查看
      _see(index, row) {
        this.$axiosget('extra/deviceEvent/detail?id=' + row.id).then(res => {
          if (res.data.status === 10000) {
            this.detailList = row
            this.detailList.deviceTypeName = res.data.data.deviceTypeName
            this.detailList.systemName = res.data.data.systemName
            this.displayForm = true
          }
        })
      },
      //搜索
      subSeefrom() {
        this.other = this.seefrom
        this.$nextTick(this.$refs.table_jsgl.getData)
      },
      //选择区域模式变化
      changeAreaMode(mode) {
        this.areaTreeVisible = true
        if (mode === 1) this.areaTreeMode = true
        if (mode === 2) this.areaTreeMode = false
        this.areaMode = mode
      },
      //区域树选择完回调
      selRegionData(a, ...b) {
        let mode = this.areaMode
        if (mode === 1) {
          this.seefrom.deviceRegion = a.id
          this.seefrom.deviceRegionName = a.name
        }
      }
    },
    mounted() {
      // 应用系统
      this.$axiosget('manager/operatingSystemApi/getOperatingSystemsByCompanyId', {
        params: {
          compayId: localStorage.getItem('companyId')
        }
      }).then(res => {
        this.systemArr = res.data.data
      })
    }
  }
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/viewEvent/index.vue